import { theme } from "../../../theme/theme";
const style = ({ variant, disabled, size }) => {
    const { space4, space6, space12, space16, borderRadius1, borderRadiusFull, borderWidth2, borderStyle, colorBgActionPrimaryDisabled, colorBorderActionSecondary, colorBgActionPrimaryPressed, colorBgActionSecondaryPressed, colorTextActionSecondary, colorTextActionPrimary, colorTextActionDisabled, colorBgActionPrimaryActiveStart, colorBgActionPrimaryActiveEnd, colorBgActionSecondaryActive, theme: themeName, } = theme();
    const baseHeight = size === "small" ? space12 : space16;
    const paddingHorizontal = space6;
    const isOutfittery = themeName === "outfittery";
    const borderRadius = isOutfittery ? borderRadius1 : borderRadiusFull;
    const container = {
        height: baseHeight,
    };
    const base = {
        alignContent: "center",
        paddingLeft: paddingHorizontal,
        paddingRight: paddingHorizontal,
        justifyContent: "center",
        overflow: "hidden",
        position: "relative",
        height: baseHeight,
        borderRadius,
    };
    const variantStyles = {
        primary: {},
        ["primary-light"]: {},
        secondary: {
            borderColor: colorBorderActionSecondary,
            borderWidth: borderWidth2,
            borderStyle: borderStyle || "solid",
            paddingLeft: paddingHorizontal,
            paddingRight: paddingHorizontal,
            height: baseHeight,
        },
    };
    const disabledVariantStyle = {
        backgroundColor: colorBgActionPrimaryDisabled,
        borderWidth: 0,
        paddingLeft: paddingHorizontal,
        paddingRight: paddingHorizontal,
    };
    const variantStyle = disabled ? disabledVariantStyle : variantStyles[variant];
    const busyColors = {
        primary: colorBgActionPrimaryPressed,
        ["primary-light"]: colorBgActionSecondaryPressed,
        secondary: colorBgActionSecondaryPressed,
    };
    const busyColor = busyColors[variant];
    const busy = {
        height: "300%",
        left: 0,
        opacity: 0.7,
        position: "absolute",
        top: 0,
        backgroundColor: busyColor,
    };
    const content = {
        alignItems: "center",
        flexDirection: "row",
        justifyContent: "center",
    };
    const textColors = {
        ["primary-light"]: colorTextActionSecondary,
        primary: colorTextActionPrimary,
        secondary: colorTextActionSecondary,
    };
    const textColor = disabled ? colorTextActionDisabled : textColors[variant];
    const gradientColors = {
        primary: [colorBgActionPrimaryActiveStart, colorBgActionPrimaryActiveEnd],
        ["primary-light"]: [colorBgActionSecondaryActive, colorBgActionSecondaryActive],
        secondary: [colorBgActionSecondaryActive, colorBgActionSecondaryActive],
    };
    const colors = disabled
        ? [colorBgActionPrimaryDisabled, colorBgActionPrimaryDisabled]
        : gradientColors[variant];
    return {
        container,
        base: { ...base, ...variantStyle },
        busy,
        content,
        colors,
        icon: {
            color: textColor,
            marginRight: space4 || 16,
        },
        text: {
            color: textColor,
            textAlign: "center",
        },
    };
};
export { style };
